import { Link } from 'react-router-dom';
import styles from './ServicesCards.module.css';

const ServicesCards = () => {
  const services = [
    {
      id: 1,
      title: 'Skilled Nursing',
      description: 'Registered nurses provide skilled care and instruction to patients and families, including wound care, medication supervision, catheter care, treatments and injections, and I.V. therapy.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
          <path d="M13 17H11V13H7V11H11V7H13V11H17V13H13V17Z" fill="currentColor"/>
        </svg>
      ),
      link: '/services/skilled-nursing'
    },
    {
      id: 2,
      title: 'Therapy Services',
      description: 'Our therapists help patients improve daily living skills such as strength, mobility, and communication while supporting families with guidance and community resources.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.49 5.48C14.03 5.48 14.51 5.27 14.87 4.92C15.23 4.56 15.44 4.08 15.44 3.54C15.44 3 15.23 2.52 14.87 2.16C14.51 1.81 14.03 1.6 13.49 1.6C12.95 1.6 12.47 1.81 12.11 2.16C11.76 2.52 11.54 3 11.54 3.54C11.54 4.08 11.76 4.56 12.11 4.92C12.47 5.27 12.95 5.48 13.49 5.48Z" fill="currentColor"/>
          <path d="M9.89 19.38L10.89 15L13 17V23H15V15.5L12.89 13.5L13.49 10.5C14.79 12 16.79 13 19 13V11C17.09 11 15.5 10 14.69 8.58L13.69 7.08C13.42 6.63 12.95 6.35 12.42 6.35C12.21 6.35 12 6.39 11.79 6.47L6 8.81V13H8V9.61L10.04 8.81L8.04 17L3.04 16L2.44 18L9.89 19.38Z" fill="currentColor"/>
        </svg>
      ),
      link: '/services'
    },
    {
      id: 3,
      title: 'Certified Home Health Aide',
      description: 'Assist patients with personal care, meal preparation, ambulation, and exercises under professional supervision to support independent living at home.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z" fill="currentColor"/>
        </svg>
      ),
      link: '/services/certified-home-health-aid'
    }
  ];

  return (
    <section className={styles.servicesSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <p className={styles.subtitle}>Remember Feeling Capable?</p>
          <h2 className={styles.heading}>
            That strength returns with the right care partnership
          </h2>
        </div>

        <div className={styles.cardsGrid}>
          {services.map((service) => (
            <Link key={service.id} to={service.link} className={styles.card}>
              <div className={styles.cardIcon}>{service.icon}</div>
              <h3 className={styles.cardTitle}>{service.title}</h3>
              <p className={styles.cardDescription}>{service.description}</p>
              <div className={styles.cardArrow}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </Link>
          ))}
        </div>

        <div className={styles.buttonWrapper}>
          <Link to="/services" className={styles.viewAllButton}>
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesCards;
